'use client';

import { Flex, Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useTranslation } from '@i18n/useTranslation';
import {
  getFlatDiscount,
  getLanguageSpecificPrice,
  getPercentageDiscount
} from '@utils/collectionUtils';

import type { Value } from '../Collection.types';

type PropertyCardProps = {
  value: Value;
  cardsWithBundle: boolean;
  cardsWithDiscount: boolean;
  mainImageId?: string;
};

export const PropertyCard = ({
  value,
  cardsWithBundle,
  cardsWithDiscount,
  mainImageId = ''
}: PropertyCardProps) => {
  const { t } = useTranslation('webshop.productPage');
  const { language } = useRequestContext();

  const discountPercentage = getPercentageDiscount(value);
  const discountFlat = getFlatDiscount(value);

  return (
    <>
      {/*If bundle and description return the card with bundle*/}
      {cardsWithBundle && value.description ? (
        <Flex gap={200} p={200}>
          <Image
            alt={value.name}
            fileCollection='product'
            height={56}
            width={56}
            imageId={mainImageId}
            loading='lazy'
            objectFit='contain'
            background='transparent'
          />

          <Flex direction='column'>
            <Flex gap={200}>
              <Typography variant='body' fontWeight={700} mb={0}>
                {value.name}
              </Typography>
              {discountFlat && (
                <Typography variant='body' color='sentimentPositive'>
                  {t('collection.discount', {
                    discountValue: getLanguageSpecificPrice(discountFlat, language)
                  })}
                </Typography>
              )}
            </Flex>

            {value.description}
          </Flex>
        </Flex>
      ) : (
        <Flex gap={200}>
          {/*Otherwise always return the card name*/}
          {value.name}
          {/*Add the discount if needed*/}
          {cardsWithDiscount && discountPercentage && (
            <Typography
              variant='body'
              component='span'
              color='sentimentPositive'
              sx={{ whiteSpace: 'nowrap' }}
            >
              {t('collection.discount', {
                discountValue: getLanguageSpecificPrice(
                  discountPercentage,
                  language,
                  cardsWithDiscount
                )
              })}
            </Typography>
          )}
        </Flex>
      )}
    </>
  );
};
